import React from "react";
import AppSwitch from "./AppSwitch";
import AppIcon from "./AppIcon"
import AppButton from "./AppButton";
import { UTILS } from "utils";
import { useTranslation } from "react-i18next";

const AppIntegrationCard=({
    icon='',
    iconImage='',
    title='',
    description="",
    url="",
    link='',
})=>{
    const { t } = useTranslation();
    const getUrl = () => {
        let platform = `?platform=${icon}`;
        if (url) {
          return url + platform;
        } else {
          const userDetail = UTILS.getCurrentUser();
          const updateUrl =
            userDetail.storeFrontURL + userDetail.temporaryDomainName + platform;
          return updateUrl;
        }
      };

    return(    
        <div className="w-full  rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
        {/* Header */}
        {
            !link && <div className="flex items-center w-full">
                <span className="flex items-center gap-2 rounded-full bg-green-100 px-3 py-1 text-xs font-medium text-green-700 mr-auto">
                    <span className="h-2 w-2 rounded-full bg-green-500" />
                    Active
                </span>
                <AppSwitch />
            </div>
        }
        

        {/* Body */}
        <div className="mt-4 flex items-start gap-3">
            {iconImage ? (
              <img
                src={iconImage}
                alt=""
                className="h-[50px] w-[50px] shrink-0 object-contain"
                width={50}
                height={50}
              />
            ) : (
              <AppIcon name={icon} size={50} />
            )}
            <div className="flex-1">
            <h3 className="text-sm font-semibold text-gray-900">
                {title}
            </h3>
            <p className="mt-1 mb-1 text-sm text-gray-500">
                {description}
                {link && <b className="text-blue-500">{link}</b>}
                
                {/* Let customers quickly place their orders directly from your
                business Instagram profile and stories. */}
            </p>
            {
                !link?<button className=" inline-flex items-center rounded-md border border-gray-300 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50" onClick={() => {navigator.clipboard.writeText(getUrl());UTILS.handleSuccesNotification(t("Copied to Clipboard"));}}>
                    Copy Link
                </button>:<AppButton >Contact Support</AppButton>
            }
            
            </div>
        </div>
        </div>
    )

}

export default AppIntegrationCard